export default __webpack_public_path__ + "static/history-of-hiv-section-hero-mobile-dee9dc6d8b8fa4dcd08e25bcbb9fdcc5.png";